// US1: Unterschriftsfelder (react-signature-canvas 1.1.0-alpha.2 / signature_pad 2.3.2), rein, ohne Importe.
// clearOnResize ist an allen Feldern AUS. Sonst löscht die Bibliothek bei JEDEM "resize" des Fensters die
// Unterschrift, und Android meldet "resize", sobald Tastatur oder Browserleisten auf- oder zugehen
// (Kundenmeldung 30.09.2026). Diese Datei passt die Zeichenfläche nur an, wenn sich ihre Größe wirklich
// geändert hat (Handy gedreht, Fenster breiter), und behält dabei das Bild.
const standardFenster = () => (typeof window === 'undefined' ? null : window);
const standardDokument = () => (typeof document === 'undefined' ? null : document);
// Beim ersten Strich den Fokus aus Eingabefeldern nehmen, damit die Handy-Tastatur zu bleibt.
// signature_pad ruft bei touchmove/touchend preventDefault() auf. Dadurch verliert z. B. das Feld
// "Ort" den Fokus beim Unterschreiben nicht, und Android öffnet die Tastatur dafür wieder.
export function eingabeVerlassen(dok = standardDokument()) {
  const aktiv = dok && dok.activeElement;
  if (!aktiv || typeof aktiv.blur !== 'function') return false;
  const art = String(aktiv.tagName || '').toUpperCase();
  if (art !== 'INPUT' && art !== 'TEXTAREA' && !aktiv.isContentEditable) return false;
  aktiv.blur();
  return true;
}
// Rückgabe: 'fehlt' | 'unsichtbar' | 'unveraendert' | 'angepasst'
export function leinwandAnpassen(feld, fenster = standardFenster()) {
  if (!feld || !fenster) return 'fehlt';
  let leinwand;
  try {
    leinwand = feld.getCanvas();
  } catch {
    return 'fehlt'; // Feld ist nicht (mehr) gemountet
  }
  if (!leinwand) return 'fehlt';
  const faktor = Math.max(fenster.devicePixelRatio || 1, 1);
  // Math.floor wie die Bibliothek: canvas.width schneidet Nachkommastellen ab (z. B. 401 x 2,625 = 1052).
  const breite = Math.floor(leinwand.offsetWidth * faktor);
  const hoehe = Math.floor(leinwand.offsetHeight * faktor);
  if (!breite || !hoehe) return 'unsichtbar';
  if (leinwand.width === breite && leinwand.height === hoehe) return 'unveraendert';
  // Bild SOFORT in eine Kopie retten. Nicht über toDataURL/fromDataURL: das Bild lädt verzögert, und ein
  // zweites "resize" kurz danach (Fenster ziehen, Drehen) hätte dann eine leere Fläche gesichert.
  let kopie = null;
  if (leinwand.width > 0 && leinwand.height > 0) {
    kopie = fenster.document.createElement('canvas');
    kopie.width = leinwand.width;
    kopie.height = leinwand.height;
    kopie.getContext('2d').drawImage(leinwand, 0, 0);
  }
  leinwand.width = breite; // leert die Fläche und setzt die Skalierung zurück
  leinwand.height = hoehe;
  const ctx = leinwand.getContext('2d');
  if (kopie) ctx.drawImage(kopie, 0, 0); // Pixel für Pixel an die alte Stelle (oben links)
  ctx.scale(faktor, faktor);
  // Bewusst KEIN feld.clear(): sonst meldet isEmpty() "leer", obwohl die Unterschrift zu sehen ist.
  return 'angepasst';
}
